import React from 'react'
import Header from '../inc/Header'
import Rooftop from './Rooftop'
import {Link} from "react-router-dom";

function Roofpage() {
    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <br/>
             <div className='besthotelberhampore'>
        <div className="album py-1">

          <div className="container mt-3">

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page"> Roof Top</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

            <Rooftop/>
            <br/>
            <br/>
        </div>
    )
}

export default Roofpage